import { FeatureFlagBuildEnvRepository } from '../../infraestructure/repositories/FeatureFlagBuildEnvRepository';

const featureFlagRepository = new FeatureFlagBuildEnvRepository();

const useFeatureFlag = () => {
    return {
        isEnabled: featureFlagRepository.isEnabled,
        reset: featureFlagRepository.reset,
    };
};

export default useFeatureFlag;
